import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import DriverLicenseControlGridItem from 'Measure/components/vehicle/driver-license/DriverLicenseControlGridItem';
import { DriverLicenseControlGridItemWrapper } from 'Measure/components/vehicle/driver-license/DriverLicenseControlGridItemWrapper';
import Loader from 'Common/components/Loader';
import RetryLoading from 'Common/components/RetryLoading';
import OuterBox from 'Common/components/Boxes/OuterBox';
import colors from 'Common/constants/colors';

const EmptyWrapper = styled(OuterBox)`
    padding: 55px 20px;
    text-align: center;
    color: ${colors.GRAY};
    font-size: 18px;
    font-weight: 300;
    line-height: 28px;

    @media screen and (min-width: 940px) {
        padding-top: 125px;
        padding-bottom: 125px;
    }
`;

const Title = styled.div`
    max-width: 580px;
    margin: 0 auto;
`;

const LoaderWrapper = styled(OuterBox)`
    padding: 40px 20px;
    border-radius: 4px;
`;

const Wrapper = styled.div`
    @media screen and (min-width: 580px) {
        display: flex;
        flex-wrap: wrap;
    }
`;

const DummyGridItem = styled(DriverLicenseControlGridItemWrapper)`
    display: none;
    box-shadow: none;

    @media screen and (min-width: 940px) {
        display: block;
        min-height: 120px;
        opacity: 0.5;
    }
`;

const minGridItems = 6;

const DriverLicenseControlsGrid = ({
    driverLicenseControls,
    onDriverLicenseControlActivate,
    onDriverLicenseControlDeactivate,
    isLoading,
    hasError,
    onReload,
}) => {
    if (isLoading) {
        return (
            <LoaderWrapper>
                <Loader />
            </LoaderWrapper>
        );
    }

    if (hasError) {
        return (
            <LoaderWrapper>
                <RetryLoading onRetry={onReload} />
            </LoaderWrapper>
        );
    }

    if (driverLicenseControls.length === 0) {
        return (
            <EmptyWrapper>
                <Title>
                    Aktuell liegen keine ausstehenden Aufgaben für Sie in der
                    Führerscheinkontrolle vor.
                </Title>
            </EmptyWrapper>
        );
    }

    return (
        <Wrapper>
            {driverLicenseControls.map(driverLicenseControl => (
                <DriverLicenseControlGridItem
                    key={driverLicenseControl.id}
                    driverLicenseControl={driverLicenseControl}
                    onActivate={async () =>
                        onDriverLicenseControlActivate(driverLicenseControl)
                    }
                    onDeactivate={async () =>
                        onDriverLicenseControlDeactivate(driverLicenseControl)
                    }
                />
            ))}

            {driverLicenseControls.length < minGridItems && (
                <>
                    {[
                        ...Array(minGridItems - driverLicenseControls.length),
                    ].map((value, index) => (
                        <DummyGridItem key={index} />
                    ))}
                </>
            )}
        </Wrapper>
    );
};

DriverLicenseControlsGrid.propTypes = {
    driverLicenseControls: PropTypes.array.isRequired,
    onDriverLicenseControlActivate: PropTypes.func.isRequired,
    onDriverLicenseControlDeactivate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    hasError: PropTypes.bool.isRequired,
    onReload: PropTypes.func.isRequired,
};

export default DriverLicenseControlsGrid;
